;(function( $ ) {
    $(window).load(function() {
        if(!$.cookie('next-geolocation-notif-view')){
            $.scrollToUp();
            // add the animation to the popover

            var $localisation = $(".localisation");

            $localisation.popover();

            function popoverClose(){
                $localisation.popover('hide');
            }

            $localisation.on('click',function () {
                popoverClose()
            });

            $localisation.parent().on('click', '.popover .popover-close',function () {
                popoverClose()
            });

            $.cookie('next-geolocation-notif-view', true, { expires: 1, path: '/' });

            setTimeout( function(){$('.localisation').popover('show');} , 2000);
        }
    });
}( jQuery ));